export default __webpack_public_path__ + "static/career@1x-ba8777a6f124c2c72357f17177cabc37.jpg";